import { AxiosRequestConfig } from 'axios';

export const assistencia24hApiConfig = {
  returnRejectedPromiseOnError: true,
  withCredentials: true,
  timeout: 20000,
  baseURL: process.env.VUE_APP_ASSISTENCIA_24H_API,
  headers: {
    common: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Content-Type": "application/json",
      Accept: "application/json, text/plain",
    },
  },
};

export const consultaVeiculoApiConfig = {
  returnRejectedPromiseOnError: true,
  withCredentials: true,
  timeout: 20000,
  baseURL: process.env.VUE_APP_CONSULTA_VEICULO_API,
  headers: {
    common: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  },
};

export const mapasApiConfig = {
  returnRejectedPromiseOnError: true,
  withCredentials: true,
  timeout: 20000,
  baseURL: process.env.VUE_APP_MAPAS_API,
  headers: {
    common: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  },
};

export const integracaoContabilApiConfig = {
  returnRejectedPromiseOnError: true,
  withCredentials: true,
  timeout: 10000,
  baseURL: process.env.VUE_APP_INTEGRACAO_CONTABIL_API,
  headers: {
    common: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Content-Type": "application/json",
      Accept: "application/json, text/plain",
    },
  },
};

export const integracaoRelatoriosGerenciaisApiConfig = {
  returnRejectedPromiseOnError: true,
  withCredentials: true,
  timeout: 10000,
  baseURL: process.env.VUE_APP_INTEGRACAO_CONTABIL_API,
  headers: {
    common: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Content-Type": "application/json",
      Accept: "application/json, text/plain",
    },
  },
};

export const orcamentoAutoOnlineApiConfig = {
  returnRejectedPromiseOnError: true,
  withCredentials: true,
  timeout: 10000,
  baseURL: process.env.VUE_APP_ORCAMENTO_AUTO_ONLINE_API,
  headers: {
    common: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Content-Type": "application/json",
      Accept: "application/json, text/plain",
    },
  },
};

export const servicosSaudeApiConfig = {
    returnRejectedPromiseOnError: true,
    withCredentials: true,
    timeout: 30000,
    baseURL: process.env.VUE_APP_SERVICOS_SAUDE_API,
    headers: {
      common: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json, text/plain, application/octet-stream",
      },
    },
  };

export const authApiConfig = {
  withCredentials: true,
  timeout: 20000,
  baseURL: process.env.VUE_APP_TOKEN_URL,
  auth: {
    username: process.env.VUE_APP_CLIENT_ID1 as string,
    client_id: process.env.VUE_APP_CLIENT_ID2 as string,
    password: '',
  },
  headers: {
    common: {
      "Cache-Control": "no-cache",
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
      Accept: "application/x-www-form-urlencoded;charset=utf-8",
    },
  },
};

export const clienteApiConfig = {
  returnRejectedPromiseOnError: true,
  withCredentials: true,
  timeout: 20000,
  baseURL: process.env.VUE_APP_CLIENTE_API,
  headers: {
    common: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Content-Type": "application/json",
      Accept: "application/json, text/plain",
    },
  },
};

export const notificacoesApiConfig = {
  returnRejectedPromiseOnError: true,
  withCredentials: true,
  timeout: 20000,
  baseURL: process.env.VUE_APP_NOTIFICACOES_API,
  headers: {
    common: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Content-Type": "application/json",
      Accept: "application/json, text/plain",
    },
  },
};